import React, {useEffect} from "react";
import Styles from './styles.module.scss'
import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import LaunchpadFreezeHistory from "../../components/launchpadFreezeHistory";
import ExtendFreezeModal from "../../components/extendFreezeModal";



const LaunchpadFreezeHistoryPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-up');
        }
    },[authStatus, navigate])

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('История заморозок')}/>
            <LaunchpadFreezeHistory/>
            <ExtendFreezeModal/>
        </section>
    );
};

export default LaunchpadFreezeHistoryPage;